export class ResCargueExcelAdminInfFiviI {
    public CONSECUTIVO: string;
    public ANIO: string;
    public MES: string;
    public OPERACION_FINANCIERA: string;
    public SEXO_TITULAR: string;
    public EDAD_TITULAR: string;
    public DESTINO_CREDITO: string;
    public SOLUCION_VIVIENDA: string;
    public DESTINO_CREDITO_VIVIENDA: string;
    public DESTINO_CREDITO_CONSTRUCCION: string;
    public DEPARTAMENTO: string;
    public MUNICIPIO: string;
    public DEPARTAMENTO_VIVIENDA: String;
    public MUNICIPIO_VIVIENDA: string;
    public SUBSIDIO: string;
    public TIPO_DE_SUBSIDIO: string;
    public MONEDA: string;
    public RANGO_VIVIENDA: string;
    public NUMERO_CREDITOS: string;
    public VALOR_AVALUO: string;
    public NUMERO_DE_DESEMBOLSO: string;
    public VALOR_CREDITO: string;
    public PLAZO_CREDITO: string;
}
